// The Twig overlays that a React dialog opens carry data-react-keep-live on their root.
export const KEEP_LIVE_SELECTOR = '[data-react-keep-live], [aria-live], [role="status"], [role="alert"]';

/**
 * Makes every element of the page inert, except `root`, the KEEP_LIVE_SELECTOR elements and their ancestors,
 * and returns the undo. An element added to <body> later (a Modal portal, a lightbox) stays live.
 *
 * @param {HTMLElement} root
 * @returns {() => void}
 */
export function inertOutside(root) {
    const keep = [root, ...Array.from(document.querySelectorAll(KEEP_LIVE_SELECTOR))];
    const marked = [];
    const walk = (parent) => {
        for (const child of Array.from(parent.children)) {
            if (!(child instanceof HTMLElement) || keep.includes(child)) continue;
            if (keep.some((element) => child.contains(element))) {
                walk(child);
                continue;
            }
            marked.push({ element: child, previous: child.inert });
            child.inert = true;
        }
    };
    walk(document.body);
    return () => {
        for (const { element, previous } of marked) element.inert = previous;
    };
}
